import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { API } from '../utils/api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // If the user was redirected here from a protected page (e.g. a shared
  // /posts/:id link), send them back there after login. Falls back to home.
  const redirectTo = location.state?.from?.pathname
    ? `${location.state.from.pathname}${location.state.from.search || ''}`
    : '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      login(response.data.access_token, response.data.user);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 24 }}>
          <img src="/logo-symbol.png" alt="socialstar" style={{ width: 60, height: 60 }} />
        </div>
        <h1 className="login-title">Welcome to socialstar</h1>
        <p className="login-subtitle">Your personal impact anchor- steady, sparkly and always cheering you</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading} data-testid="login-submit-btn">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <button type="button" data-testid="forgot-password-link"
            onClick={() => navigate('/forgot-password')}
            style={{ display: 'block', margin: '12px auto 0', background: 'none', border: 'none',
              color: '#4DB6AC', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
            Forgot password?
          </button>
        </form>

        {/* <div className="demo-info">
          <strong>Demo Account:</strong><br />
          demo@socialstar.com / demo123
        </div> */}

        {/* <div
          data-testid="demo-register-link-block"
          style={{
            marginTop: 16, paddingTop: 16, borderTop: '1px solid #E5E7EB',
            textAlign: 'center',
          }}
        >
          <button
            type="button"
            data-testid="demo-register-link"
            onClick={() => navigate('/demo-register')}
            style={{
              background: 'none', border: 'none', color: '#4DB6AC',
              fontSize: 14, fontWeight: 700, cursor: 'pointer', padding: 0,
            }}
          >
            Try it as a new user →
          </button>
          <div style={{ marginTop: 6, fontSize: 12, color: '#6B7280' }}>
            Create a demo account to explore socialstar
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;
